import { Alert, AlertTitle, alpha, Box, Button, Typography } from '@mui/material';
import { reportTypes } from '../../../../helpers/appstate';
import Slider from 'react-slick'; // No need for the 'Import' alias unless you prefer it
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowForward, PieChartOutline } from '@mui/icons-material';

export default function PersonnelAlert({ resultList, resultLoading }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 400, // Fast transition animation (0.4s)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // Stay on screen for 3s before sliding
    arrows: false,
    fade: false, // REQUIRED: This enables the "sliding" motion
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)', // Standard MUI easing curve
    pauseOnHover: true, // Good UX so users can read the alert
  };

  const currentYear = new Date().getFullYear();

  const avaiableQaqcResults =
    resultList?.filter(
      (x) => x?.reportType === reportTypes.QAQC && x?.reportYear === currentYear && !x?.isVisible
    ) || [];

  const renderAvailableQaQcResults = () => {
    if (avaiableQaqcResults.length > 0) {
      return (
        <Slider {...settings}>
          {avaiableQaqcResults.map((i, index) => (
            <Box sx={{ px: 1 }}>
              <Alert
                severity="info"
                icon={<PieChartOutline fontSize="inherit" />}
                action={
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    sx={{ borderRadius: 2, textTransform: 'none', mr: 1 }}
                    endIcon={<ArrowForward />}
                  >
                    View Result
                  </Button>
                }
                sx={{
                  borderRadius: '16px',
                  border: '1px solid',
                  borderColor: 'info.light',
                  bgcolor: alpha('#0288d1', 0.05), // Very soft blue background
                  alignItems: 'center',
                  boxShadow: '0px 4px 12px rgba(2, 136, 209, 0.05)',
                }}
              >
                <AlertTitle
                  sx={{
                    fontWeight: 700,
                    mb: 0.25,
                    display: 'flex',
                    gap: 0.5,
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    color={i?.reportType === 'QAQC' ? 'warning' : 'primary'}
                  >
                    {i?.reportType}
                  </Typography>{' '}
                  Result is ready
                </AlertTitle>
                <Typography>
                  {i?.reportTitle} is available for {i?.facility}
                </Typography>
              </Alert>
            </Box>
          ))}
        </Slider>
      );
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', my: 2 }}>
      {/* CALL THE FUNCTION HERE */}
      {renderAvailableQaQcResults()}
    </Box>
  );
}
